import React from "react";
import { VMBuilder } from "../../../../commons/base/providers/builder";
import SOAdjustmentViewModel from "../view_models/so_adjustment_view_model";
import Select from "react-select";

export default class SOAdjustmentFilterWidget extends React.Component {
    render(): React.ReactNode {
        return (
            <VMBuilder<SOAdjustmentViewModel>>
                {(vm) => (
                    <div className="flex flex-wrap items-center mb-5 space-y-3 md:space-y-0">
                        <div className="relative mr-2">
                            <Select
                                options={vm.locations.map((option) => ({
                                    value: option.id,
                                    label: option.name,
                                }))}
                                placeholder={"Pilih Lokasi SO"}
                                isClearable={true}
                                isSearchable={true}
                                onChange={(option) => {
                                    if (option?.value) {
                                        vm.fetchSOList(option?.value);
                                    }
                                }}
                            />
                        </div>
                    </div>
                )}
            </VMBuilder>
        );
    }
}
